import {IScope, ITimeoutService, IWindowService} from 'angular';
import {PaycellService} from '../../buy/services/paycell.service';
import {Action} from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import {ActionHandler} from '../../common/actions/core/action-handler';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { FamilyPlanTypes } from '../../common/services/package/package.model';


import {OpenStartListenAction} from './family-plan-member-start-listen-dialog.action';

/* @ngInject */
export default class FamilyPlanUserRegistrationDialogController implements ActionHandler {
  private dialogElement;
  public memberNewAddress: any;
  public memberEmail: any;
  public memberBirthday: string;
  public memberDay: any;
  public memberMonth: any;
  public memberYear: any;
  public membersMasterToken: any;
  public type: FamilyPlanTypes;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $state,
    private $scope: IScope,
    private $timeout: ITimeoutService,
    private paycellService: PaycellService,
    private googleAnalytics: GoogleAnalyticsService,
    private $window: IWindowService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#family-plan-member-start-listen-dialog').remodal();

  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenStartListenAction) {
      this.type = action.type;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onGoInfo() {
    this.close();
    this.$window.open('https://fizy.in/Ps93n', '_blank');
  }

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
    if(this.isDuoPackage()) {
      this.$state.go('duoPlanMemberInfo');
    } else{
      this.$state.go('familyPlanMemberInfo');
    }
  }

  public onClose() {
    this.close();
  }

  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member-start-listen-dialog/family-plan-member-start-listen-dialog.controller.ts